import { HttpService } from "../http";
import { getBaseUrl } from "@root/store/selectors/features";
import { store } from "@root/store";

export class RiskAssessmentService extends HttpService {
  baseUrl = getBaseUrl(store.getState());

  fetchRiskAssessments = async (payload: any = {}): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments`;
    try {
      const apiResponse = await this.get(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addRiskAssessment = async (payload: any): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments`;
    try {
      const apiResponse = await this.post(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateRiskAssessment = async (id: number, payload: any): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments/${id}`;
    try {
      const apiResponse = await this.patch(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteRiskAssessment = async (id: number): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments/${id}`;
    try {
      const apiResponse = await this.delete(apiUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  getRiskAssessmentById = async (id: number | string): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments/${id}`;
    try {
      const apiResponse = await this.get(apiUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  analyzeRiskAssessment = async (id: number | string): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/assessments/analyze/${id}`;
    try {
      const apiResponse = await this.get(apiUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Suggested Questions API
  fetchSuggestedQuestions = async (payload: any = {}): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/suggested-questions`;
    try {
      const apiResponse = await this.get(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
